export const AZURE_STATES = {
    NEW: 'new',
    NEXT_UP: 'next_up',
    NOT_STARTED: 'not_started',
    RESOLVED: 'resolved',
    CLOSED: 'closed'
};
